import { Slider } from "@mui/material";
import { ExampleFilterListProps, ExampleFilterSliderProps } from "@usereactify/search";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useOnClickOutside } from "../../hooks/useOnClickOutside";
import { FiltersBox } from "./FiltersBox";

// TODO: maybe extra the dropdown logic into a separate component?
// Right now all 3 filters are using the same dropdown logic, but they are not the same

export const MyFilterSlider: React.FC<ExampleFilterSliderProps> = (props) => {
  const min = props.filterSliderProps.value[0];
  const max = props.filterSliderProps.value[1];

  // Put this always at the top, otherwise it will break the slider
  if (min === max) return <div></div>;

  const getValueFromPercent = (percent: number) => {
    return ((max - min) * (percent / 100) + min).toFixed(2);
  };

  const [isOpen, setIsOpen] = useState(false);

  const ref = useRef(null);
  useOnClickOutside(ref, () => setIsOpen(false));

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const rangeValuesData = useMemo<[number, number]>(() => {
    const { value } = props.filterSliderProps;
    if (value.length < 1 || (value[0] === 0 && value[1] === 0)) {
      return [0, 100];
    }
    const [min, max] = value;
    const [minVal, maxVal] = value;
    const minPercent = ((minVal - min) / (max - min)) * 100;
    const maxPercent = ((maxVal - min) / (max - min)) * 100;
    return [minPercent, maxPercent];
  }, [props.filterSliderProps.value]);
  const [rangeValues, setRangeValues] = useState<[number, number]>([0, 100]);

  useEffect(() => {
    setRangeValues(rangeValuesData);
  }, [rangeValuesData]);

  return (
    <div className="relative dropdown-box" ref={ref}>
      <button onClick={toggleDropdown} className={"btnClasses"}>
        <span className="font-body text-body inline-flex filter-heading">{props.filter.name}</span>{" "}
        {isOpen ? (
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.99854 0.53808L0.0292969 6.50732L0.983892 7.46191L5.99988 2.44592L11.0159 7.46191L11.9705 6.50732L6.00123 0.53808L5.99988 0.539427L5.99854 0.53808Z"
              fill="#2D2926"
            />
          </svg>
        ) : (
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.99951 6.96168L11.9687 0.992437L11.0142 0.0378417L5.99816 5.05383L0.982171 0.0378408L0.0275764 0.992436L5.99682 6.96168L5.99816 6.96033L5.99951 6.96168Z"
              fill="#2D2926"
            />
          </svg>
        )}
      </button>
      <div
        className={
          isOpen
            ? `dropdown-list white-bg overflow-hidden transition-all open`
            : `dropdown-list white-bg overflow-hidden transition-all`
        }
      >
        <div className="dropdown-list-content dropdown-slider-content">
          <Slider
            valueLabelDisplay="on"
            valueLabelFormat={(value) => {
              return props.filterSliderProps.filter.name.toLowerCase() === "price"
                ? `$${getValueFromPercent(value)}`
                : // if is width or height or depth, then add the 'cm':
                props.filterSliderProps.filter.name.toLowerCase() === "width" ||
                  props.filterSliderProps.filter.name.toLowerCase() === "height" ||
                  props.filterSliderProps.filter.name.toLowerCase() === "depth"
                ? `${value}cm`
                : `${value}`;
            }}
            value={rangeValues}
            onChangeCommitted={(_, newValue) => {
              setRangeValues(newValue as [number, number]);
              const range = props.filterSliderProps.value;
              if (Array.isArray(newValue)) {
                const min = range[0];
                const max = range[1];
                const minVal = (max - min) * (newValue[0] / 100) + min;
                const maxVal = (max - min) * (newValue[1] / 100) + min;
                props.filterSliderProps.handleChange([minVal, maxVal]);
              }
            }}
            onChange={(_, newValue) => {
              setRangeValues(newValue as [number, number]);
            }}
          />

          {/* <div className="dropdown-min-max-text">
            {props.filterSliderProps.range.map((range, index) => (
              <div>
                {props.filterSliderProps.filter.name.toLowerCase() === "price" ? `$${range.toFixed(2)}` : `${range}`}
              </div>
            ))}
          </div> */}
        </div>
      </div>
    </div>
  );
};

// export const MyFilterRange: React.FC<ExampleFilterRangeProps> = (props) => {
//   // props.filter.
//   return <div>TEST range option 2</div>;
// };

export const MyFilterList: React.FC<ExampleFilterListProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const ref = useRef(null);
  useOnClickOutside(ref, () => setIsOpen(false));

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative dropdown-box" ref={ref}>
      <button onClick={toggleDropdown} className={"btnClasses"}>
        <span className="font-body text-body inline-flex filter-heading">{props.filter.name}</span>{" "}
        {isOpen ? (
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.99854 0.53808L0.0292969 6.50732L0.983892 7.46191L5.99988 2.44592L11.0159 7.46191L11.9705 6.50732L6.00123 0.53808L5.99988 0.539427L5.99854 0.53808Z"
              fill="#2D2926"
            />
          </svg>
        ) : (
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.99951 6.96168L11.9687 0.992437L11.0142 0.0378417L5.99816 5.05383L0.982171 0.0378408L0.0275764 0.992436L5.99682 6.96168L5.99816 6.96033L5.99951 6.96168Z"
              fill="#2D2926"
            />
          </svg>
        )}
      </button>
      <div
        className={
          isOpen
            ? `dropdown-list white-bg overflow-hidden transition-all open`
            : `dropdown-list white-bg overflow-hidden transition-all`
        }
      >
        <div className="dropdown-list-content">
          <ul className="no-bullets tag-list tag-list--active-tags">
            <FiltersBox filterListProps={props.filterListProps} isSizeGuide={false} setFilterOpen={setIsOpen} />
          </ul>
        </div>
      </div>
    </div>
  );
};
